<template>
  <div role="tablist">
    <template v-for="group in group(value)">
      <work-type-accordion :key="group.id" :group="group" @remove="remove" @removeGroup="removeGroup" />
    </template>
  </div>
</template>

<script>
import groupWorkTypes from "@/imports/mixins/groupWorkTypes";
import notification from "@/imports/mixins/notification";
import WorkTypeAccordion from "@/components/list/WorkTypeAccordion";

export default {
  name: "Basket",
  components: {WorkTypeAccordion},
  mixins: [groupWorkTypes, notification],
  props: ['value'],
  methods: {
    remove: function(workType){
      this.notify(
        this.$bvToast,
        `Lead type "${workType.description}" removed`,
        null,
        'success'
      );
      this.$emit('input', this.value.filter(wt => wt.id !== workType.id));
    },
    removeGroup: function(categoryName) {
      this.notify(
        this.$bvToast,
        `Lead type group "${categoryName}" removed`,
        null,
        'success'
      );
      this.$emit('input', this.value.filter(workType => workType.category.name !== categoryName));
    }
  }
}
</script>

<style scoped>

</style>
